import {connect} from "react-redux"
import {IncomingHttpHeaders} from "http"
import State from "../../ducks/state"
import urls from "../../config/urls"
import {REALM_HEADER} from "../../config/constants"
import {updateBag, addEVoucherToBag} from "../../ducks/shoppingbag"

export const mapStateToProps = (state: State) => {
    const realm = (state.request.headers as IncomingHttpHeaders)[REALM_HEADER] as string
    const {
        text: {
            shoppingBag: {altText},
        },
        request: {siteUrl, cleanSiteUrl},
        settings: {variant, iconsVersionPath, enableMinibagNotification, isTpSuperLite},
    } = state
    const {itemCount, loading} = state.shoppingBag
    const {shoppingBag} = urls
    return {
        altText,
        smallIconUrl: shoppingBag.smallIconUrl(realm, variant, iconsVersionPath),
        largeIconUrl: shoppingBag.largeIconUrl(realm, variant, iconsVersionPath),
        itemCount,
        isBagLoading: loading,
        shoppingBagUrl: `${isTpSuperLite ? cleanSiteUrl : siteUrl}${urls.shoppingBag.url}`,
        enableMinibagNotification,
    }
}

export const mapDispatchToProps = dispatch => ({
    updateShoppingBag: (data: any) => {
        dispatch(updateBag(data))
    },
    addEVoucherToBag: (data: any) => {
        dispatch(addEVoucherToBag(data))
    },
})

export default connect(mapStateToProps, mapDispatchToProps)
